import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg width="1em" height="1em" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#prefix__clip0)">
      <path
        d="M.5 39.3V1.7C.5 1 1 .5 1.7.5h37.7c.6 0 1.2.5 1.2 1.2v37.7c0 .6-.5 1.2-1.2 1.2H1.7C1 40.5.5 40 .5 39.3z"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 4.5H3v5h35v-5zM38 13.8H3v5h35v-5zM38 23H3v5h35v-5z"
        stroke="fj-icons-primary-color"
        strokeWidth={0.561}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3 32.7h-11c-1.1 0-2 .9-2 2s.9 2 2 2h11c1.1 0 2-.9 2-2s-.9-2-2-2z"
        fill="fj-icons-primary-color"
      />
      <path
        d="M10.9 25.5l6.8-2.5-4.3-4.4-2.5 6.9z"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeWidth={0.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.8 25.6l2.6-.9-1.7-1.7-.9 2.6z" fill="fj-icons-primary-color" />
      <path
        d="M28.8 11.9l-4.4-4.4 1.8-1.8c.2-.2.6-.2.9 0l3.5 3.5c.2.2.2.6 0 .9l-1.8 1.8z"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M28.78 11.929l-4.385-4.384-11.03 11.03 4.384 4.385 11.03-11.031z"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeWidth={0.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="fj-icons-bg-color" d="M0 0h41v41H0z" />
      </clipPath>
    </defs>
  </svg>
);

const CustomFields = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default CustomFields;
